module.exports = __webpack_public_path__ + "img/faqbg.e9287105.png";